import React from 'react';
import { Phone, MessageCircle, Mail, MapPin } from 'lucide-react';
import { businessInfo } from '../mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${businessInfo.whatsapp}?text=Hi, I'm interested in your marble polishing services`, '_blank');
  };

  return (
    <footer className="bg-gray-900 text-white" data-testid="footer">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">GS</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">G.S Contractors</h3>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed mb-4">
              Your trusted partner for premium marble, granite, and tile polishing services in Bangalore. Quality workmanship guaranteed.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Marble Cutting & Fixing</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Granite Cutting & Fixing</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Italian Marble Laying & Finishing</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Marble & Granite Polishing</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Interior Stone & Inlay Work</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-emerald-400" />
                <a href={`tel:${businessInfo.phone}`} data-testid="footer-phone-link" className="hover:text-emerald-400 transition-colors">
                  {businessInfo.phone}
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-emerald-400" />
                <a href={`mailto:${businessInfo.email}`} data-testid="footer-email-link" className="hover:text-emerald-400 transition-colors">
                  {businessInfo.email}
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-1" />
                <span>{businessInfo.location}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} G.S Contractors. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <button 
                onClick={handleWhatsApp}
                data-testid="footer-whatsapp-button"
                className="text-emerald-400 hover:text-emerald-300 transition-colors font-medium"
              >
                WhatsApp
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
